import { ElementRef } from '@angular/core';
import { SCHWAB_SSO_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { SchwabSsoService } from 'AccountsApp/ts/services/schwab-sso-form.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "AccountsApp/ts/services/schwab-sso-form.service";
const _c0 = ["schwabSsoForm"];
const _c1 = ["schwabEncodedResponse"];
export class SchwabSsoFormComponent {
    constructor(featureService, schwabSsoService) {
        this.featureService = featureService;
        this.schwabSsoService = schwabSsoService;
    }
    login() {
        if (!this.featureService.userHasFeatures([SCHWAB_SSO_FEATURE])) {
            return;
        }
        this.schwabSsoService.getSchwabSSOSaml().subscribe((res) => {
            // Encode the SAML XML response
            this.schwabEncodedResponse.nativeElement.value = window.btoa(res.signed_saml_response);
            // Set the appropriate destination URL for the form
            this.schwabSsoForm.nativeElement.action = res.destination_url;
            this.schwabSsoForm.nativeElement.submit();
        });
    }
}
SchwabSsoFormComponent.ɵfac = function SchwabSsoFormComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SchwabSsoFormComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SchwabSsoService)); };
SchwabSsoFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SchwabSsoFormComponent, selectors: [["ycn-schwab-sso-form"]], viewQuery: function SchwabSsoFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.schwabSsoForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.schwabEncodedResponse = _t.first);
    } }, standalone: false, decls: 4, vars: 0, consts: [["schwabSsoForm", ""], ["schwabEncodedResponse", ""], ["method", "post", "target", "_blank", 2, "display", "none"], ["type", "hidden", "name", "SAMLResponse"]], template: function SchwabSsoFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 2, 0);
        i0.ɵɵelement(2, "input", 3, 1);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
